import { data } from "../data/ingredientData";
import { IngredientType, IngredientTypeName } from "../data/ingredientModel";
import { createDiv, createElem, getOneByClass, scrollToElement } from "../util";
import { Item } from "./item";

export class Inventory {
    div: HTMLElement;
    items: Item[] = [];
    itemsByType = new Map<IngredientType, Item[]>();
    tabs: HTMLElement[] = [];
    currentTabIndex = -1;

    constructor() {
        this.populateIngredients();
    }

    populateIngredients() {
        for (let ing of data) {
            var ingredient = new Item(ing);
            this.items.push(ingredient);
            if (!this.itemsByType[ing.type]) {
                this.itemsByType[ing.type] = [];
            }
            this.itemsByType[ing.type].push(ingredient);
        }
    }

    createElement() {
        this.div = getOneByClass("inventory");

        const ingredientsList = getOneByClass("ingredients-list", this.div);
        const tabs = getOneByClass("tabs", this.div);

        for (let i = 0; i < IngredientTypeName.length - 1; i++) {
            var typeName = IngredientTypeName[i];

            // Add tab
            var tab = createDiv(tabs, "tab");
            var icon = createElem("img", tab, "icon") as HTMLImageElement;
            icon.src = `assets/ingredients/${typeName.toLowerCase()}_icon.png`;

            tab.onclick = () => this.selectTab(i);
            this.tabs.push(tab);

            // Add divider + ingredients
            var divider = createDiv(ingredientsList, "divider");
            divider.id = typeName;
            createElem("h3", divider, "", typeName);

            for (let item of this.itemsByType[i]) {
                item.createElement(ingredientsList);
            }
        }

        this.selectTab(0);
    }

    selectTab(index: number) {
        // TODO to keep track of current tab index need to track what's visible when scrolling
        // if (index != this.currentTabIndex) {
        //     this.tabs[this.currentTabIndex]?.classList.remove("active");

        //     this.currentTabIndex = index;
        //     this.tabs[this.currentTabIndex].classList.add("active");
        // }
            // scroll to divider for this tab
            //var divider = document.getElementById(IngredientTypeName[index]);
            //divider.scrollIntoView();
            const scrollable = getOneByClass("ingredients-list", this.div);
            scrollToElement(IngredientTypeName[index], scrollable, -40);
    }
}